<template>
  <tr>
    <td>
      <div class="form-field">
        <input-field
          placeholder="Escriba una descripción..."
          :id="index + 'descripcion'"
          v-model="modelValue.descripcion"
        ></input-field>
      </div>
    </td>
    <td>
      <div class="form-field">
        <input-field
          vMoney
          :format="money"
          placeholder="Escriba un valor..."
          :id="index + 'desde'"
          v-model="modelValue.desde"
        ></input-field>
      </div>
    </td>
    <td>
      <div class="form-field">
        <input-field
          vMoney
          :format="money"
          placeholder="Escriba un valor..."
          :id="index + 'hasta'"
          v-model="modelValue.hasta"
        ></input-field>
      </div>
    </td>
    <td>
      <div class="form-field">
        <input-field
          vMoney
          :format="money"
          placeholder="Escriba un valor..."
          :id="index + 'valor'"
          v-model="modelValue.valor"
        ></input-field>
      </div>
    </td>
    <td>
      <div class="form-field">
        <input-field
          vMoney
          :format="money"
          placeholder="Escriba un valor..."
          :id="index + 'comision'"
          v-model="modelValue.comision"
        ></input-field>
      </div>
    </td>
    <td>
      <button class="btn-danger btn--text" type="button" @click="eliminar">
        <i class="fa fa-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      required: false,
      default: function () {
        return {
          descripcion: "",
          desde: "",
          hasta: "",
          valor: "",
          comision: "",
        };
      },
    },
  },
  data: function () {
    return {
      modelValue: this.value,
      money: money,
    };
  },
  methods: {
    eliminar: function () {
      this.$emit("eliminar", this.index);
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/general/TrRango.vue